function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  transform: "translate(2 2)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M2.7062,5.5347 L0.5862,7.6547 C-0.1948,8.4367 -0.1948,9.7037 0.5862,10.4857 L7.6552,17.5547 C8.4362,18.3357 9.7042,18.3357 10.4852,17.5547 L17.5552,10.4857 C18.3362,9.7037 18.3362,8.4367 17.5552,7.6547 L10.4852,0.5857 C9.7042,-0.1953 8.4362,-0.1953 7.6552,0.5857 L5.5352,2.7067 L12.6052,9.7777"
}),
/*#__PURE__*/
React.createElement("line", {
  x1: 9.07,
  x2: 9.07,
  y1: 13.313,
  y2: 6.242
}));

var SvgRepository = function SvgRepository(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref)
  );
};

export default SvgRepository;